import * as api from '../api';

export const MailLogoDeleteFile = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .remove('/mailler/deletefile', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const SendTestMail = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post('/mailler/send_test_mail', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const MailLogoUpload = (data, file_type, history) => {
    return new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append("file", data);
        formData.append("file_type", file_type);

        api
            .post('/mailler/uploadfile', formData,
                {
                    headers: { "Content-Type": "multipart/form-data", },
                }
            )
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const GetSettingsEmail = (history) => {
    return new Promise((resolve, reject) => {
        api
            .get('/mailler/settings')
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const UpdateSettingsEmail = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .put('/mailler/settings', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const UpdateMailtemplates = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .put('/mailler/mailtemplates', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const GetTemplates = (id, history) => {
    return new Promise((resolve, reject) => {
        api
            .get(`/settings/templates/${id}`)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const ImagePrepairUpload = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post('/settings/image_upload', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const CustomerSettingsImageDelete = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .remove('/settings/image', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const CustomerInfraSettings = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post('/settings/infra_settings', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const GetPlublicPlugins = (history) => {
    return new Promise((resolve, reject) => {
        api
            .get('/public/plugins')
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};


export const GetPluginOauthConnectURL = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post('/settings/plugin_oauth_connect', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const AddNewPlugin = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post('/settings/plugin_settings', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const TogglePluginStatus = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .put('/settings/plugin_status', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const GetPluginConfig = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post('/settings/plugin_config', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const UpdatePluginConfig = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .put('/settings/plugin_update', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const DeletePlugin = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .remove('/settings/plugin_delete', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const CustomerPluginSettingsUpdate = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .put('/settings/plugin_settings/update', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const CustomerSettings = (customer_id, history) => {
    return new Promise((resolve, reject) => {
        api
            .get(`/settings/customer/${customer_id}`)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const TemplateDefaults = (template, history) => {
    return new Promise((resolve, reject) => {
        api
            .get(`/settings/template_defaults/${template}`)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const UpdateCustomerBrandingSettings = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .put('/settings/branding_settings', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const UpdateCustomerFinancialSettings = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .put('/settings/financial_settings', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const UpdateCustomerHolidaySettings = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .put('/settings/holiday_settings', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const GetCustomerLedgers = (history) => {
    return new Promise((resolve, reject) => {
        api
            .get('/settings/ledgers/list')
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const BookingSettings = (history) => {
    return new Promise((resolve, reject) => {
        api
            .get('/settings/booking')
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const UpdateBookingSettings = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .put('/settings/booking_settings', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const AddContractTemplate = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post('/settings/html_template', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const GetTemplateSettingsList = (history) => {
    return new Promise((resolve, reject) => {
        api
            .get('/settings/html_template/list')
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const GetHTMLTemplate = (template_id, history) => {
    return new Promise((resolve, reject) => {
        api
            .get(`/settings/html_template/${template_id}`)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const SaveContractTemplate = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .put(`/settings/html_template`, data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const DeleteHTMLTemplate = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .remove(`/settings/html_template`, data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const SaveAdvancedTemplate = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .put(`/settings/template/advanced`, data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const ContractFilePrepairUpload = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post('/settings/html_template/file_upload', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const DeleteContractFile = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .remove('/settings/html_template/file_delete', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const GenerateTestContractFile = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post('/settings/html_template/test_generator', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const AddField = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post('/settings/field', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const UpdateField = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .put('/settings/field', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const DeleteField = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .remove('/settings/field', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const GetCostsCenters = (history) => {
    return new Promise((resolve, reject) => {
        api
            .get('/settings/costs_centers')
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const AddCouponCode = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post('/settings/coupon_code', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const EditCouponCode = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .put('/settings/coupon_code', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};


export const DeleteCouponCode = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .remove('/settings/coupon_code', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};


export const GetCustomerCustomFields = (history) => {
    return new Promise((resolve, reject) => {
        api
            .get(`/settings/customer_custom_fields`)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const AddCustomerCustomField = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post(`/settings/customer_custom_field`, data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const UpdateCustomerCustomField = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .put(`/settings/customer_custom_field`, data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const DeleteCustomerCustomField = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .remove(`/settings/customer_custom_field`, data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};
